import { getProductPlans } from "api/subscription/getProductPlans";
import { ProductPlan } from "components/Payment/SubscriptionPlans";

export const fetchDodoProductPlans = async (
  setProductPlans: (productPlans: ProductPlan[]) => void
) => {
  const productPlans = await getProductPlans();
  setProductPlans(productPlans);
};
